import { ModelValidation } from "@/models/modelvalidation";

export class IosContent extends ModelValidation {
    public callerName!: string | null;
    public callDescription!: string | null;
    public imageData!: string | null;

    public callerNameX!: string | null;
    public callDescriptionX!: string | null;
    public imageDataX!: string | null;

    public callerName17!: string | null;
    public callDescription17!: string | null;
    public imageData17!: string | null;


    constructor(ios: any) {
        super();

        this.imageData = ios.contact.imageData || null;
        this.callerName = ios.contact.callerName || null;
        this.callDescription = ios.contact.callDescription || null;

        this.imageDataX = ios.contactx.imageData || null;
        this.callerNameX = ios.contactx.callerName || null;
        this.callDescriptionX = ios.contactx.callDescription || null;
        
        this.imageData17 = (ios.contact17 != null) ? ios.contact17.imageData : null;
        this.callerName17 = (ios.contact17 != null) ? ios.contact17.callerName : null;
        this.callDescription17 = (ios.contact17 != null) ? ios.contact17.callDescription : null;
        
    }

    public static empty(): IosContent
    {
        return new IosContent({
            contact: {
                imageData: null,
                callerName: null,
                callDescription: "${MY_VAR}$",
            },
            contactx: {
                imageData: null,
                callerName: null,
                callDescription: "${MY_VAR}$",
            },
            contact17: {
                imageData: null,
                callerName: null,
                callDescription: "${MY_VAR}$",
            }
        });
    }

    public toUpdateContentDto(): any {
        return {
            contact: {
                imageData: this.imageData,
                callDescription: "${MY_VAR}$",
                callerName: this.callerName,
            },
            contactx: {
                imageData: this.imageDataX,
                callDescription: "${MY_VAR}$",
                callerName: this.callerNameX,
            },
            contact17: {
                imageData: this.imageData17,
                callDescription: "${MY_VAR}$",
                callerName: this.callerName17,
            }
        };
    }

    public updateImage(imgData: string): void {
        const tag = "data:image/jpeg;base64,";

        if (imgData!.includes(tag)) {
            this.imageData = imgData;
        } else {
            this.imageData = tag + imgData;
        }
    }

    public updateImageX(imgData: string): void {
        const tag = "data:image/jpeg;base64,";        
        if (imgData!.includes(tag)) {
            this.imageDataX = imgData;
        } else {
            this.imageDataX = tag + imgData;
        }                
    }

    public updateImage17(imgData: string): void {
    
        const tag = "data:image/jpeg;base64,";

        if (imgData!.includes(tag)) {
            this.imageData17 = imgData;
        } else {
            this.imageData17 = tag + imgData;
        }
    }

    public isValid(): boolean {
        var isValid = false;

        if(
            (this.callerName && this.callerName.length > 0) &&
            (this.callerNameX && this.callerNameX.length > 0) &&
            (this.callerName17 && this.callerNameX.length > 0) &&
            (this.imageData && this.imageData.length > 0) &&
            (this.imageDataX && this.imageDataX.length > 0) && 
            (this.imageData17 && this.imageDataX.length > 0)
        ) {
            isValid = true;
        }

        return isValid;
    }

}
